/**
 * Converts days to milliseconds
 */
export const daysToMs = (days: number): number => Math.floor(days * (1000 * 60 * 60 * 24))

/**
 * Converts hours to milliseconds
 */
export const hoursToMs = (hours: number): number => Math.floor(hours * (1000 * 60 * 60))

/**
 * Converts minutes to milliseconds
 */
export const minutesToMs = (minutes: number): number => Math.floor(minutes * (1000 * 60))

/**
 * Converts seconds to milliseconds
 */
export const secondsToMs = (seconds: number): number => Math.floor(seconds * 1000)
